import { Grid, Card, CardHeader, CardContent } from '@mui/material';
import { Hub, CheckCircle, ErrorOutline, VpnKey, SwapHoriz, Speed } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { StatCard } from '../../components/StatCard';
import { MiniBarChart } from '../../components/MiniBarChart';
import { EmptyState } from '../../components/EmptyState';
import { integrationApi } from '../../api/integration.api';

const n = (x = 0) => Number(x).toLocaleString('en-IN');

function ChartCard({ title, data }: { title: string; data: Array<{ label: string; value: number }> }) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title={title} titleTypographyProps={{ variant: 'subtitle1' }} />
      <CardContent>{data.length ? <MiniBarChart data={data.map((d) => ({ ...d, color: '#1e40af' }))} /> : <EmptyState title="No data yet" dense />}</CardContent>
    </Card>
  );
}

export function IntegrationDashboardPage() {
  const { data } = useQuery({ queryKey: ['integration', 'dashboard'], queryFn: () => integrationApi.dashboard() });
  const k = data?.kpis;
  const c = data?.charts;

  return (
    <>
      <PageHeader title="Integration Dashboard" subtitle="API gateway, connectors, keys and traffic analytics across all external systems." />
      <Grid container spacing={2} mb={1}>
        <Grid item xs={6} sm={4} lg={2}><StatCard gradient color="#1e40af" label="Integrations" value={n(k?.totalIntegrations)} icon={<Hub />} /></Grid>
        <Grid item xs={6} sm={4} lg={2}><StatCard gradient color="#16a34a" label="Active" value={n(k?.activeIntegrations)} icon={<CheckCircle />} /></Grid>
        <Grid item xs={6} sm={4} lg={2}><StatCard gradient color="#dc2626" label="Errored" value={n(k?.erroredIntegrations)} icon={<ErrorOutline />} /></Grid>
        <Grid item xs={6} sm={4} lg={2}><StatCard gradient color="#7c3aed" label="API Keys" value={n(k?.activeApiKeys)} icon={<VpnKey />} /></Grid>
        <Grid item xs={6} sm={4} lg={2}><StatCard gradient color="#0d9488" label="API Calls" value={n(k?.totalCalls)} icon={<SwapHoriz />} /></Grid>
        <Grid item xs={6} sm={4} lg={2}><StatCard gradient color="#d97706" label="Avg Latency" value={`${n(k?.avgDurationMs)} ms`} icon={<Speed />} hint={`${k?.errorRate ?? 0}% error rate`} /></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}><ChartCard title="By Category" data={c?.byCategory ?? []} /></Grid>
        <Grid item xs={12} md={4}><ChartCard title="By Direction" data={c?.byDirection ?? []} /></Grid>
        <Grid item xs={12} md={4}><ChartCard title="By Status" data={c?.byStatus ?? []} /></Grid>
      </Grid>
    </>
  );
}
